import theme from '../../base';

const switchComponent = {
  default: {
    background: theme.colors.neutrals.gray500,
    thumbBackground: theme.colors.neutrals.white,
    border: theme.colors.neutrals.gray500,
  },
  disabled: {
    background: theme.colors.neutrals.gray250,
    thumbBackground: theme.colors.neutrals.white,
    border: theme.colors.neutrals.gray250,
  },
  focus: {
    border: theme.colors.blues.blue300,
  },
  selected: {
    background: theme.colors.blues.blue500,
    thumbBackground: theme.colors.neutrals.white,
    border: theme.colors.blues.blue500,
  },
  label: {
    foreground: theme.colors.neutrals.gray800,
  },
};

export default switchComponent;
